import React from "react";
import { NavLink } from "react-router-dom";

export default function ConfirmationCommentary() {
  return (
    <div className="confirmation-commentary-container">
      <div className="card">
      Votre souhait a bien été pris en compte. Nous vous tiendrons
      informé(e) de la suite donnée à votre demande à partir du lundi 15 juin.
      <NavLink to="/inscrire-un-joueur">
        <button className="buttons">C'est noté</button>
      </NavLink>
      </div>
    </div>
  );
}
